import React from 'react';
import AvoirsLPP from '../components/AvoirsLPP';
import SEO from '../components/SEO';

const AvoirsLPPPage = () => {
  return (
    <>
      <SEO 
        title="Avoirs LPP - Retrouver mes avoirs de prévoyance professionnelle | ATOM Group"
        description="Service 100% digital pour retrouver vos avoirs de prévoyance professionnelle oubliés. Recherche gratuite et sécurisée dans toute la Suisse."
        keywords="avoirs LPP, prévoyance professionnelle, 2ème pilier, avoirs oubliés, Suisse"
      />
      <AvoirsLPP />
    </>
  );
};

export default AvoirsLPPPage;